var map = {
	"./CustomerService.vue": "0c1d",
	"./SvgIcon.vue": "c45e",
	"./TheFooter copy.vue": "8869",
	"./TheFooter.vue": "34fd",
	"./TheHeader.vue": "bc13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc83";